module.exports = __webpack_public_path__ + "media/images/purchase-plan-banner-4dfe9f0294256d8946f1fc87ab41c1d9.jpg";